import React from 'react'
import { withRouter } from 'react-router-dom'
import glamorous from 'glamorous'
import { ThemeProvider } from '@paypalcorp/pp-react'
import Preview from './preview'

const Wrapper = glamorous.div({
  margin: '2.25rem 0 2rem',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
})

function SlugSellerRecipientProfile(props) {
  return (
    <Wrapper>
      <ThemeProvider theme="v2">
        <Preview {...props} />
      </ThemeProvider>
    </Wrapper>
  )
}
export default withRouter(SlugSellerRecipientProfile)
